export default __webpack_public_path__ + "static/80559-db50db801a3a0f598ee00d30140f5b3a.jpg";